import {useNavigate} from "react-router-dom";

import {DIGITAL_SHELF_ROUTES} from "@constants";
import {brand, category, country, keyword, retailer} from "@signals"
import {batch} from "@preact/signals-react";
import {shareOfSearchIsCategoryCurrent, shareOfSearchIsCountryCurrent, shareOfSearchIsRetailerCurrent} from "../@signals";

export default function useShareOfSearchRedirect() {
	const navigate = useNavigate();

	const _goTo = (valueFilter, keywordID, route) => {
		if (shareOfSearchIsCountryCurrent.value)
			country.value = [valueFilter]
		else if (shareOfSearchIsRetailerCurrent.value)
			retailer.value = [valueFilter]
		else if (shareOfSearchIsCategoryCurrent.value)
			category.value = [valueFilter]
		else brand.value = [valueFilter]
		keyword.value = [keywordID]
		batch(() => navigate(route))
	}

	const goToKeywordDetails = (valueFilter, keywordID) => _goTo(valueFilter, keywordID, DIGITAL_SHELF_ROUTES.KEYWORD_PATH)

	return {
		goToKeywordDetails
	}
}